module.exports = __webpack_public_path__ + "9b0b2f2cd2b5f7c0814962c4fef4e021.jpg";